const vi = {
  pauseIllustrations: 'Dừng chuyển động minh hoạ', resumeIllustrations: 'Tiếp tục chuyển động minh hoạ', illustrationsReduced: 'Đã giảm chuyển động theo cài đặt',
  appSearch: 'Tìm nhiệm vụ minh hoạ', allTasks: 'Tất cả', noTasks: 'Không có ví dụ phù hợp. Hãy thử từ khác.',
  demoRate: 'Đơn giá / phút hữu ích', demoRateValue: 'Không đặt đơn giá trong bản demo',
  demoTaskType: 'Hoạt động thường ngày', demoGuidance: 'Xem hướng dẫn và chuẩn bị',
  taskStage: 'Nhiệm vụ', preparationStage: 'Chuẩn bị', deviceStage: 'Camera Ego',
  appGuide: 'Chọn việc. Chuẩn bị. Ghi hình.',
  appGuideBody: 'Thử chọn nhiệm vụ và chuẩn bị camera Ego. Trải nghiệm từng bước ngay tại đây.',
  appDataNote: 'Các nhiệm vụ dưới đây là ví dụ; không có đơn giá, số chỗ hay tiến độ thực tế.',
  productTasks: 'Một nhiệm vụ cụ thể', productTasksBody: 'Hoạt động và hướng dẫn được xác định trước khi thu thập.',
  productReview: 'Một quyết định của con người', productReviewBody: 'Phần được chấp nhận có lý do và số phút hữu ích riêng.',
  settingsTitle: 'Những nơi quen thuộc.', settingsBody: 'Hình ảnh bối cảnh để hình dung hoạt động thường ngày. Câu chuyện người thu thập sẽ được bổ sung khi có sự đồng ý.',
  stockLabel: 'Ảnh bối cảnh minh hoạ · không phải địa điểm thu thập đã xác nhận',
  settingHome: 'Ở nhà', settingWork: 'Góc làm việc', settingOutside: 'Ngoài trời', settingEveryday: 'Không gian thường ngày',
  storiesSoon: 'Câu chuyện đang được chuẩn bị', storiesBody: 'Chưa có nhận xét hay đánh giá từ người thu thập để công bố.',
  faqDevice: 'Camera được đeo và điều khiển thế nào?', faqJoin: 'Cần chuẩn bị gì trước khi nhận nhiệm vụ?',
  footerExplore: 'Khám phá', footerStart: 'Bắt đầu', footerPrivacy: 'Quyền riêng tư',
};
type Copy = Record<keyof typeof vi, string>;
const en: Copy = {
  pauseIllustrations: 'Pause illustration motion', resumeIllustrations: 'Resume illustration motion', illustrationsReduced: 'Reduced motion is enabled',
  appSearch: 'Search example tasks', allTasks: 'All tasks', noTasks: 'No matching examples. Try another search.',
  demoRate: 'Rate / effective minute', demoRateValue: 'No rate set in this demo',
  demoTaskType: 'Everyday activity', demoGuidance: 'Read guidance and prepare',
  taskStage: 'Task', preparationStage: 'Preparation', deviceStage: 'Ego camera',
  appGuide: 'Choose. Prepare. Capture.',
  appGuideBody: 'Try choosing a task and preparing your Ego camera. Walk through each step right here.',
  appDataNote: 'These tasks are examples; no live rates, available places or progress are shown.',
  productTasks: 'A specific task', productTasksBody: 'The activity and its guidance are defined before collection.',
  productReview: 'A human decision', productReviewBody: 'Accepted material has its own reasons and effective minutes.',
  settingsTitle: 'Places you know.', settingsBody: 'Illustrative settings for everyday activity. Collector stories will be added when consented material is available.',
  stockLabel: 'Illustrative setting · not a confirmed collection location',
  settingHome: 'At home', settingWork: 'A place to work', settingOutside: 'Outdoors', settingEveryday: 'Everyday spaces',
  storiesSoon: 'Stories are being prepared', storiesBody: 'No collector reviews or ratings are available to publish yet.',
  faqDevice: 'How is the camera worn and controlled?', faqJoin: 'What comes before claiming a task?',
  footerExplore: 'Explore', footerStart: 'Get started', footerPrivacy: 'Privacy',
};
const zh: Copy = {
  pauseIllustrations: '暂停插图动画', resumeIllustrations: '继续插图动画', illustrationsReduced: '已启用减少动态效果',
  appSearch: '搜索示例任务', allTasks: '全部任务', noTasks: '没有匹配的示例，请尝试其他关键词。',
  demoRate: '每有效分钟单价', demoRateValue: '演示未设置单价',
  demoTaskType: '日常活动', demoGuidance: '查看指引并准备',
  taskStage: '任务', preparationStage: '准备', deviceStage: 'Ego 相机',
  appGuide: '选任务。做准备。开始拍摄。',
  appGuideBody: '选择任务，准备好 Ego 相机。在这里逐步体验。',
  appDataNote: '下列任务仅为示例，不显示实际单价、名额或进度。',
  productTasks: '一个明确的任务', productTasksBody: '采集前确定活动内容及相关指引。',
  productReview: '一次人工判断', productReviewBody: '获接受的内容有相应原因及有效分钟数。',
  settingsTitle: '熟悉的地方。', settingsBody: '日常活动的示意场景。获得同意的素材可用后，将加入采集者故事。',
  stockLabel: '场景示意图 · 并非已确认的采集地点',
  settingHome: '在家中', settingWork: '工作角落', settingOutside: '户外', settingEveryday: '日常空间',
  storiesSoon: '故事正在准备中', storiesBody: '目前没有可公开的采集者评价或评分。',
  faqDevice: '如何佩戴和控制相机？', faqJoin: '领取任务之前需要做什么？',
  footerExplore: '探索', footerStart: '开始', footerPrivacy: '隐私',
};
export const DISCOVER_WARM_COPY = {vi,en,zh};
